export class MultiPanelElement {

    /**
     * @param {HTMLElement} element
     */
    constructor(element) {
        this._element = element;
        this._onHashChange = this._onHashChange.bind(this);
        window.addEventListener('hashchange', this._onHashChange);
    }

    /**
     * The currently active panel element will usually be the title's next element sibling and have the role "tabpanel"
     * (i.e. the content container, not the panel container containing the title)
     * @returns {Element}
     */
    get activePanel() {
        throw new TypeError('getter `activePanel` is not implemented');
    }

    set activePanel(value) {
        throw new TypeError('setter `activePanel` is not implemented');
    }

    get panels() {
        return Array.from(this._element.querySelectorAll('[role=tabpanel]'));
    }

    /**
     * Under this name the class instance will be made available to the element given to the constructor.
     * With this it will be possible to use e.g. `$0._accordion.activePanel = $._accordion.panels[0];`
     * @returns {string}
     */
    static get elementProperty() {
        return '_multiPanel';
    }

    openPanel(panel, targetState) {
        this.activePanel = targetState ? panel : null;
    }

    _construct() {
        this._element[this.constructor.elementProperty] = this;
    }

    destroy() {
        delete this._element[this.constructor.elementProperty];
        window.removeEventListener('hashchange', this._onHashChange);
    }

    _onHashChange() {
        const hash = document.location.hash.substr(1);
        if (hash.length) {
            const element = document.querySelector(`a[name="${hash}"],[id="${hash}"]`);
            if (element !== null && this._element.contains(element)) {
                const panels = this.panels;
                for (let i = 0; i < panels.length; i++) {
                    if (panels[i].contains(element)) {
                        this.activePanel = panels[i];
                        window.setTimeout(() => {
                            element.scrollIntoView(true);
                            window.scrollTo({ top: window.scrollY - 150 });
                        }, 10);
                        break;
                    }
                }
            }
        }
    }
}
